<template>
  <div class="form-row">
    <div class="form-group col-12">
      <p class="font-weight-bold">Select Character</p>
      <div class="models-wrapper">
        <div
          v-for="(model, key) in fbxModels"
          :key="key"
          class="model-item"
          @click="changeSelectedModel(key, model)"
          :class="{ active: activeModel === model.title }"
        >
          <img :src="model.image.imageURL" class="img-fluid" />
          <p>{{ model.name }}</p>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapActions, mapState } from 'vuex'

export default {
  components: {},
  data() {
    return {
      activeModel: "Select Model",
      inputData: {}
    };
  },
  created () {
    // this.listFBXModels()
  },

  methods: {
    // ...mapActions(['listFBXModels']),
    changeSelectedModel (index, model) {
      console.log('there')
      this.activeModel = model.name
      this.allCharacters = this.characters.map((char) => ({ ...char, active: false }))
      // this.$store.dispatch('updateCharacters', this.characters.map((char) => ({ ...char, active: false,characterElements:[] })))
      let selectedOne = {
        AndroidAssetBundle: model.asset_bundle.Android.fileURL,
        bakedLighting: '',
        characterElements: [],
        dimensions: [1, 2, 1],
        endTime: 10,
        iOSAssetBundle: model.asset_bundle.iOS.fileURL,
        webglAssetBundle: model.asset_bundle.WebGL.fileURL,
        interactiveSurface: '',
        layer: 1,
        material: '',
        name: model.name,
        objectDbHash: index,
        objectId: Math.floor(Date.now() / 1000),
        origin: {
          position: [0.2, 0.1, 0.1],
          rotation: [0, 0, 0]
        },
        polygonCount: 1,
        presenceDuration: 10,
        rigType: 'Humanoid',
        scale: model.scale || 1,
        startTime: 0,
        type: 'Character',
        active: true
      }
      this.$store.dispatch('updateCharacters', [
        ...this.allCharacters,
        selectedOne
      ])
      this.$emit('triggerSelectedModel', { index, model })
      this.$emit('closePopup')
    }
  },
  mounted () {},
  watch: {},
  computed: {
    ...mapState(['fbxModels','characters'])
  }
};
</script>



// WEBPACK FOOTER //
// src/components/v2/story-edit-view/timeline-components/character.vue